import POSTS from "../data/posts.json";
import { SITE, TESTIMONIALS } from "../data/site";

/* Blog content lives in src/data/posts.json. Each post has metadata plus a
   list of content blocks: p, h2, ul, ol, table, steps and quote.
   scripts/prerender-blog.js reads the same file after the build to write a
   static HTML page per post with the right title, description and preview image. */

export const BLOG_PATH = "/blog";

export const postPath = (slug) => `${BLOG_PATH}/${slug}`;

/* 1200×630 JPG for WhatsApp/Facebook link previews (WebP isn't shown everywhere). */
export const ogImagePath = (slug) => `${BLOG_PATH}/og/${slug}.jpg`;

/* Newest first. */
export const getPosts = () => [...POSTS].sort((a, b) => b.date.localeCompare(a.date));

export const getPost = (slug) => POSTS.find((p) => p.slug === slug);

export const getTestimonial = (name) => TESTIMONIALS.find((t) => t.name === name);

export const formatDate = (iso) =>
    new Date(`${iso}T00:00:00`).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });

/* The Get Found → Get Booked → Get Growing series. */
export const stageNeighbours = (post) => {
    if (!post.stage) return {};
    const byStage = (n) => POSTS.find((p) => p.stage === n);
    return { prev: byStage(post.stage - 1), next: byStage(post.stage + 1) };
};

/* Up to `count` other posts, preferring the same category. */
export const relatedPosts = (post, count = 3) => {
    const others = getPosts().filter((p) => p.slug !== post.slug);
    const same = others.filter((p) => p.category === post.category);
    const rest = others.filter((p) => p.category !== post.category);
    return [...same, ...rest].slice(0, count);
};

/* Keep in step with articleJsonLd in scripts/prerender-blog.js. */
export const articleJsonLd = (post) => ({
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: post.title,
    description: post.description,
    image: `${SITE.domain}${post.cover}`,
    datePublished: post.date,
    dateModified: post.date,
    keywords: post.keywords,
    articleSection: post.category,
    mainEntityOfPage: `${SITE.domain}${postPath(post.slug)}`,
    author: { "@type": "Organization", name: SITE.name, url: SITE.domain },
    publisher: {
        "@type": "Organization",
        name: SITE.name,
        logo: { "@type": "ImageObject", url: `${SITE.domain}${SITE.logoFull}` },
    },
});
